import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=02654e86&scoped=true"
import script from "./TextItem.vue?vue&type=script&lang=js"
export * from "./TextItem.vue?vue&type=script&lang=js"
import style0 from "./TextItem.vue?vue&type=style&index=0&id=02654e86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02654e86",
  null
  
)

export default component.exports